import React, { useEffect, useMemo, useState } from "react";
import Button from "@mui/material/Button";
import "../servicesOperation.css";
import InputAutocomplete from "../InputAutocomplete_Form";
import Grid from "@mui/material/Unstable_Grid2";
import Box from "@mui/material/Box";
import {
  options_origen_devolucion,
  options_deposito_destino,
  options_condicion,
  options_sintoma,
  options_aceptamos_devolucion_safe,
  data_aceptamos_devolucion,
  options_tecnico_responsable,
  options_lote,
} from "../Helper/data_Admin";
import { TextField, Typography } from "@mui/material";

const label = { inputProps: { "aria-label": "Checkbox demo" } };

// Definimos el componente Admin
const Admin_Form_Body = ({
  formData,
  setFormData,
  isLoading,
  isSubmitting,
  dataCondicion,
  dataDeposito_destino,
  dataOrigen_devolucion,
  dataSintoma,
  dataAceptamos_Dev,
  dataTecnico_responsable,
  dataLote,
  guardarInfoError,
  handleSubmit,
  datataller_deposito_destino,
  setDataTaller_deposito_destino,
}) => {
  const [checkBox, setCheckBox] = useState(false);

  //Estados para validación de cada input
  const [touched, setTouched] = useState({});
  const [errors, setErrors] = useState({});

  // Función para marcar un campo como tocado
  const handleBlur = (id) => {
    setTouched((prevState) => ({
      ...prevState,
      [id]: true,
    }));
    validateField(id, formData[id]);
  };

  const validateField = (id, value) => {
    // Si el valor es nulo o el string vacío, establecer el error
    if (!value) {
      setErrors((prevState) => ({
        ...prevState,
        [id]: "Este campo es obligatorio",
      }));
    } else {
      // Eliminar el error si el campo es válido
      setErrors((prevState) => {
        const newState = { ...prevState };
        delete newState[id];
        return newState;
      });
    }
  };

  //Función para filtrar las opciones de Depósito Destino
  const filterDepositoDestinoOptions = (containsDonato) => {
    if (!containsDonato) {
      setDataTaller_deposito_destino(dataDeposito_destino); // Restablecer a todas las opciones si no hay iniciales
      return;
    }
    //Filtra por aquellas opciones tengan Donato, y filtra las que incluyan "Taller"
    const filteredOptions = dataDeposito_destino.filter(
      (option) =>
        option.name.includes("Donato") && !option.name.includes("Taller"),
    );
    setDataTaller_deposito_destino(filteredOptions);
  };

  //Captura Inputs Autocomplete
  const handleChangeAutoComplete = (id, newInputValue) => {
    const newId = newInputValue ? newInputValue.id : null;
    // console.log(newId);
    // console.log(id);

    setFormData((prevState) => ({
      ...prevState,
      [id]: newId,
    }));

    //setTouched({ ...touched, [id]: true }); // Marca el campo como tocado
    setTouched((prevState) => ({ ...prevState, [id]: true }));
    // Validar después de actualizar
    validateField(id, newId);

    //Añadir filtro condicional de Depósito Destino
    if (id === "id_deposito_dest") {
      //Guarda la inicial después del primer "("
      const containsDonato = newInputValue
        ? newInputValue.name.includes("Donato")
        : null;
      filterDepositoDestinoOptions(containsDonato);
    }
  };

  //Captura valor Checkbox
  const handleChangeCheckBox = (event) => {
    const newCheckBoxValue = event.target.checked;
    setCheckBox(newCheckBoxValue);
    setFormData((prevState) => ({
      ...prevState,
      movimientos_vs_inicial: newCheckBoxValue,
    }));
  };

  const origenDevSeleccionado = dataOrigen_devolucion.find(
    (option) => option.id === formData["id_origen_dev"],
  );

  const deposito_dest_Seleccionado = dataDeposito_destino.find(
    (option) => option.id === formData["id_deposito_dest"],
  );

  // const condicion_Seleccionado = dataCondicion.find(
  //   (option) => option.id === formData["id_condicion"],
  // );

  const sintoma_Seleccionado = dataSintoma.find(
    (option) => option.id === formData["id_sintoma"],
  );

  const aceptamos_dev_Seleccionado = dataAceptamos_Dev.find(
    (option) => option.id === formData["id_aceptamos_devolucion"],
  );

  const deposito_destino_Seleccionado = datataller_deposito_destino.find(
    (option) => option.id === formData["id_taller_deposito_destino"],
  );

  const tecnico_responsable_Seleccionado = dataTecnico_responsable.find(
    (option) => option.id === formData["id_tecnico_responsable"],
  );

  const lote_Seleccionado = dataLote.find(
    (option) => option.id === formData["id_lote"],
  );

  //Función para habilitar o bloquear botón de Enviar una vez que haya datos en cada Input
  const isFormValid = useMemo(() => {
    // Asumiendo que formData es un objeto que contiene todos los campos del formulario como propiedades
    const requiredFields =
      deposito_dest_Seleccionado && !deposito_dest_Seleccionado.isworkshop
        ? [
            "id_origen_dev",
            "id_deposito_dest",
            // "id_condicion",
            "id_sintoma",
            "id_aceptamos_devolucion",
            "id_taller_deposito_destino",
            "id_tecnico_responsable",
            "id_lote",
            "publicaciones_sku",
          ]
        : [
            "id_origen_dev",
            "id_deposito_dest",
            // "id_condicion",
            "id_sintoma",
            "id_aceptamos_devolucion",
            // "id_taller_deposito_destino",
            "id_tecnico_responsable",
            "id_lote",
            "publicaciones_sku",
          ];

    // Verifica si alguno de los campos requeridos está vacío
    return requiredFields.every((field) => {
      const value = formData[field];
      if (typeof value === "string") {
        return value.trim() !== "";
      } else if (typeof value === "number") {
        return value !== 0;
      } else {
        return value !== null && value !== undefined; // Asume que para los booleanos, solo verificar si no son nulos o indefinidos
      }
    });
  }, [formData, deposito_dest_Seleccionado]);

  const cleanForm = () => {
    //Limpiar solo los campos que son editables por el usuario
    setFormData({
      ...formData,
      id_origen_dev: null,
      id_deposito_dest: null,
      id_sintoma: null,
      id_aceptamos_devolucion: null,
      id_taller_deposito_destino: null,
      id_tecnico_responsable: null,
      id_lote: null,
      publicaciones_sku: "",
    });
    setTouched({});
    setErrors({});
    setCheckBox(false);
  };

  const isDisabled = () => {
    return !isFormValid || isLoading || isSubmitting;
  };

  return (
    <>
      {isLoading ? (
        <></>
      ) : (
        <>
          {/* export default function InputAutocomplete({id, options, label, onInputChange}) { */}
          <Box
            sx={{
              flexGrow: 1,
              gap: "16px",
              flexDirection: "column",
              display: "flex",
              marginTop: "16px",
            }}
          >
            <Typography
              variant="h6"
              sx={{
                fontWeight: 600,
                fontSize: "14px",
                lineHeight: "24px",
                letterSpacing: "0.15px",
                color: "#00000061",
              }}
            >
              Gestión SOA
            </Typography>
            <Grid
              container
              spacing={{ xs: 2, md: 3 }}
              columns={{ xs: 4, sm: 8, md: 12 }}
            >
              <Grid item xs={12} sm={4} md={4} key="1">
                <InputAutocomplete
                  id="id_origen_dev"
                  value={origenDevSeleccionado || null}
                  label="Origen Devolución"
                  onChange={(event, newValue) =>
                    handleChangeAutoComplete("id_origen_dev", newValue)
                  } // handleFormDataChange
                  error={Boolean(
                    touched?.["id_origen_dev"] && errors?.["id_origen_dev"],
                  )}
                  onBlur={() => handleBlur("id_origen_dev")}
                  required={true}
                  helperText={
                    touched["id_origen_dev"] && errors["id_origen_dev"]
                  }
                  options={
                    dataOrigen_devolucion
                      ? dataOrigen_devolucion.map((condicion) => ({
                          name: condicion.name,
                          id: condicion.id,
                        }))
                      : options_origen_devolucion
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                  getOptionLabel={(option) => option.name || ""}
                />
              </Grid>
              <Grid item xs={12} sm={4} md={4} key="2">
                <InputAutocomplete
                  id="id_deposito_dest"
                  value={deposito_dest_Seleccionado || null}
                  label="Destino Devolución"
                  onChange={(event, newValue) => {
                    handleChangeAutoComplete("id_deposito_dest", newValue);
                    handleChangeAutoComplete(
                      "id_taller_deposito_destino",
                      null,
                    );
                  }}
                  error={
                    touched["id_deposito_dest"] &&
                    Boolean(errors["id_deposito_dest"])
                  }
                  onBlur={() => handleBlur("id_deposito_dest")}
                  required={true}
                  helperText={
                    touched["id_deposito_dest"]
                      ? errors["id_deposito_dest"]
                      : ""
                  }
                  options={
                    dataDeposito_destino
                      ? dataDeposito_destino.map((condicion) => ({
                          name: condicion.name,
                          id: condicion.id,
                        }))
                      : options_deposito_destino
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                />
              </Grid>
              {/* <Grid item xs={12} sm={4} md={4} key="3">
                <InputAutocomplete
                  id="id_condicion"
                  value={condicion_Seleccionado || null}
                  label="Condición"
                  onChange={(event, newValue) =>
                    handleChangeAutoComplete("id_condicion", newValue)
                  }
                  error={
                    touched["id_condicion"] && Boolean(errors["id_condicion"])
                  }
                  onBlur={() => handleBlur("id_condicion")}
                  required={true}
                  helperText={
                    touched["id_condicion"] ? errors["id_condicion"] : ""
                  }
                  options={
                    dataCondicion
                      ? dataCondicion.map((condicion) => ({
                          name: condicion.name,
                          id: condicion.id,
                        }))
                      : options_condicion
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                />
              </Grid> */}
              <Grid item xs={12} sm={4} md={4} key="4">
                <InputAutocomplete
                  id="id_sintoma"
                  value={sintoma_Seleccionado || null}
                  label="Síntoma"
                  onChange={(event, newValue) =>
                    handleChangeAutoComplete("id_sintoma", newValue)
                  }
                  error={touched["id_sintoma"] && Boolean(errors["id_sintoma"])}
                  onBlur={() => handleBlur("id_sintoma")}
                  required={true}
                  helperText={touched["id_sintoma"] ? errors["id_sintoma"] : ""}
                  options={
                    dataSintoma
                      ? dataSintoma.map((condicion) => ({
                          name: condicion.name,
                          id: condicion.id,
                        }))
                      : options_sintoma
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                />
              </Grid>
              <Grid item xs={12} sm={4} md={4} key="5">
                <InputAutocomplete
                  id="id_aceptamos_devolucion"
                  value={aceptamos_dev_Seleccionado || null}
                  label="Aceptamos la devolucion"
                  onChange={(event, newValue) =>
                    handleChangeAutoComplete(
                      "id_aceptamos_devolucion",
                      newValue,
                    )
                  }
                  error={
                    touched["id_aceptamos_devolucion"] &&
                    Boolean(errors["id_aceptamos_devolucion"])
                  }
                  onBlur={() => handleBlur("id_aceptamos_devolucion")}
                  required={true}
                  helperText={
                    touched["id_aceptamos_devolucion"]
                      ? errors["id_aceptamos_devolucion"]
                      : ""
                  }
                  options={
                    dataAceptamos_Dev
                      ? dataAceptamos_Dev.map((condicion) => ({
                          name: condicion.name,
                          id: condicion.id,
                        }))
                      : data_aceptamos_devolucion
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                  getOptionLabel={(option) => option.nombre_estado || ""}
                />
              </Grid>
              {deposito_dest_Seleccionado &&
                !deposito_dest_Seleccionado.isworkshop && (
                  <Grid item xs={12} sm={4} md={4} key="8">
                    <InputAutocomplete
                      id="id_taller_deposito_destino"
                      value={deposito_destino_Seleccionado || null}
                      label="Depósito destino"
                      onChange={(event, newValue) =>
                        handleChangeAutoComplete(
                          "id_taller_deposito_destino",
                          newValue,
                        )
                      }
                      error={
                        touched["id_taller_deposito_destino"] &&
                        Boolean(errors["id_taller_deposito_destino"])
                      }
                      onBlur={() => handleBlur("id_taller_deposito_destino")}
                      required={true}
                      helperText={
                        touched["id_taller_deposito_destino"]
                          ? errors["id_taller_deposito_destino"]
                          : ""
                      }
                      options={
                        datataller_deposito_destino
                          ? datataller_deposito_destino.map((condicion) => ({
                              name: condicion.name,
                              id: condicion.id,
                            }))
                          : options_deposito_destino
                      }
                      isOptionEqualToValue={(option, value) =>
                        option.id === value.id
                      }
                    />
                  </Grid>
                )}
              <Grid item xs={12} sm={4} md={4} key="9">
                <InputAutocomplete
                  id="id_tecnico_responsable"
                  value={tecnico_responsable_Seleccionado || null}
                  label="Tecnico responsable"
                  onChange={(event, newValue) =>
                    handleChangeAutoComplete("id_tecnico_responsable", newValue)
                  }
                  error={
                    touched["id_tecnico_responsable"] &&
                    Boolean(errors["id_tecnico_responsable"])
                  }
                  onBlur={() => handleBlur("id_tecnico_responsable")}
                  required={true}
                  helperText={
                    touched["id_tecnico_responsable"]
                      ? errors["id_tecnico_responsable"]
                      : ""
                  }
                  options={
                    dataTecnico_responsable
                      ? dataTecnico_responsable.map((condicion) => ({
                          name: condicion.name,
                          id: condicion.id,
                        }))
                      : options_tecnico_responsable
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                />
              </Grid>
              {/* Lote */}
              <Grid item xs={12} sm={4} md={4} key="10">
                <InputAutocomplete
                  id="id_lote"
                  value={lote_Seleccionado || null}
                  label="Lote"
                  onChange={(event, newValue) =>
                    handleChangeAutoComplete("id_lote", newValue)
                  }
                  error={touched["id_lote"] && Boolean(errors["id_lote"])}
                  onBlur={() => handleBlur("id_lote")}
                  required={true}
                  helperText={touched["id_lote"] ? errors["id_lote"] : ""}
                  options={
                    dataLote
                      ? dataLote.map((condicion) => ({
                          name: condicion.name,
                          id: condicion.id,
                        }))
                      : options_lote
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                />
              </Grid>
            </Grid>
          </Box>

          {/* <div className="checkbox_container">
            <p>Marque el tilde si hubo movimiento de Virtual Seller</p>
            <Checkbox
              onChange={handleChangeCheckBox}
              checked={checkBox}
              {...label}
              sx={{ "& .MuiSvgIcon-root": { fontSize: 28 } }}
            />
          </div> */}

          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              mt: 2,
              gap: 2,
            }}
          >
            <Button
              type="button"
              variant="outlined"
              onClick={cleanForm}
              style={{
                color: "#002878",
                fontWeight: 500,
                borderColor: "#002878",
                "&:hover": { borderColor: "#002878" },
                width: "120px",
                textTransform: "uppercase",
              }}
            >
              Cancelar
            </Button>
            <Button
              type="submit"
              variant="contained"
              style={{
                color: isDisabled() ? "rgba(0, 0, 0, 0.26)" : "white",
                backgroundColor: isDisabled() ? "#0000001F" : "#002878",
                "&:hover": {
                  backgroundColor: isDisabled() ? "#0000001F" : "#002878",
                },
                width: "200px",
                textTransform: "uppercase",
              }}
              color="primary"
              disabled={isDisabled()}
              onClick={(e) => handleSubmit(e, "finalize")} // pasar 'finalize' como tipo de acción
            >
              GUARDAR Y ASIGNAR
            </Button>
          </Box>
        </>
      )}
    </>
  );
};

export default Admin_Form_Body;
